import { z } from "zod";
import { exerciseClip } from "../catalog/exercise-list";
/**
 * The persistent *"never recommend this again"* list (`D06`) —
 * `GET`/`POST /me/exclusions` and `DELETE /me/exclusions/:exerciseId`.
 *
 * ── IT IS NOT A SUBSTITUTION ────────────────────────────────────────────────
 * Swapping one exercise out of one session is a plan edit and lives on the
 * plan. This list outlives the plan: it is read on every generate and every
 * substitute query, so an exercise excluded once never comes back through a
 * regeneration, a protocol change or an automatic swap.
 */
/**
 * The cap, and a BOUND rather than a preference.
 *
 * The list is read on every generate and every substitute query, and an
 * unbounded `NOT IN` is a `T-6` row-read problem — D1 bills rows read, not
 * queries. On reaching the cap the route answers
 * `ConflictError("exclusion.limit_reached")` with `params: { max }`; the
 * client chooses the words (`D27`).
 */
export const MAX_EXCLUSIONS = 200;
export const excludedExercise = z.object({
    /** The poster and its clip, male first then female — the same object and the
     *  same order `planItemView.exercise.clip` carries, so the row draws the
     *  plate the rest of the app draws. `null`: the exercise has no clip.
     *  ABSENT: a server older than the field, and the row is then text only. */
    clip: exerciseClip.nullable().optional(),
    excludedAt: z.iso.datetime(),
    exerciseId: z.string().min(1),
    /** The exercise's name in the request's locale, for rendering the list. */
    name: z.string().min(1),
    /** The TARGET muscle, in the request's locale — the *"{muscle} · fora
     *  desde …"* line. ABSENT: a server older than the field. */
    primaryMuscle: z
        .object({ id: z.int().positive(), name: z.string().min(1) })
        .optional(),
});
export const exclusionListOutput = z.object({
    rows: z.array(excludedExercise),
});
export const addExclusionInput = z.strictObject({
    exerciseId: z.string().min(1),
});
//# sourceMappingURL=exclusion.js.map